import React from 'react';
import styles from './ErrorMessage.css';

export default function ErrorMessage(props) {
  const { children } = props;
  return <div className={styles.errorMessage}>{children}</div>;
}
